import { gql, useQuery } from "@apollo/client";
import { DEBT_AGE_BAND_KEYS } from "./columns";

const debtAgeFields = DEBT_AGE_BAND_KEYS.join("\n      ");

const GET_SALES_DEBT_AGING = gql`
  query GetSalesDebtAging(
    $region: ID
    $district: ID
    $tariffClass: ID
    $tariffClasses: [ID]
    $serviceClass: ServiceClass
    $serviceClasses: [ServiceClass]
    $accountType: AccountType
    $ministry: ID
    $mda: ID
    $isSensitive: Boolean
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
    $category: String
  ) {
    rows: getSales(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      accountType: $accountType
      ministry: $ministry
      mda: $mda
      isSensitive: $isSensitive
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
      category: $category
    ) {
      _id
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      geoCode
      accountCode
      meterCode
      regionName
      districtName
      soeName
      mdaName
      ministryName
      isSensitive
      customerName
      amountDue
      debtAmount
      debtAge {
        ${debtAgeFields}
      }
    }
    count: getSalesCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      accountType: $accountType
      ministry: $ministry
      mda: $mda
      isSensitive: $isSensitive
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
      category: $category
    )
  }
`;

export const useSalesDebtAging = (variables: any) => {
  const { data, ...rest } = useQuery(GET_SALES_DEBT_AGING, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};
